
import Vue from "vue";
export default Vue.extend({
	props: {
		value: {
			type: String,
		}
	},
	i18nEx: {
		componentPrefix: "components.settings-default"
	}
});
